import React from 'react';
import cx from 'classnames';

import styles from './Tabs.module.scss';

const Tabs = ({ children, className, centered }) => {
    return (
        <ul className={cx(className, styles.tabs, { [styles.tabsCentered]: centered })}>
            {children}
        </ul>
    )
}

export default Tabs;
